import React from 'react'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { StatusSelectInlineInput } from '@ztechapps/webui.data-tools'
import type { UnitOfMeasure } from '@ztechapps/common.contract'
import { LocalDateTime } from '@ztechapps/webui.date'
import { InlineInput, NumberInlineInput } from '@ztechapps/webui.input'
import { UnitOfMeasureCategorySelectInlineInput } from '../select/UnitOfMeasureCategorySelect'
import { ShowIf } from '@ztechapps/webui.util'
import { UnitOfMeasureInlineInput } from './UnitOfMeasureInlineInput'
import { Badge } from 'react-bootstrap'

export const DataListRow = (props: BodyRowConfig<UnitOfMeasure>) => {
  const { _id, code, name, symbol, category, conversionFactor, status, updatedAt } = props
  const isReferenceUnit = conversionFactor === 1
  const initialValues = { _id, code, name, symbol, category, conversionFactor, status }

  return props._renderDataBodyCell({
    code: (
      <div className="fw-bold text-uppercase">
        {code}
        <ShowIf condition={isReferenceUnit}>
          <Badge bg="info" className="ms-1 fw-normal">
            ref
          </Badge>
        </ShowIf>
      </div>
    ),

    name: (
      <UnitOfMeasureInlineInput
        name="name"
        initialValues={initialValues}
        hoverToEdit={true}
        parentInputComponent={InlineInput}
      />
    ),

    symbol: (
      <UnitOfMeasureInlineInput
        name="symbol"
        initialValues={initialValues}
        hoverToEdit={true}
        parentInputComponent={InlineInput}
      />
    ),

    category: (
      <UnitOfMeasureInlineInput
        name="category"
        initialValues={initialValues}
        parentInputComponent={UnitOfMeasureCategorySelectInlineInput}
        inputProps={{ isClearable: false }}
      />
    ),

    conversionFactor: (
      <div className="text-end">
        <UnitOfMeasureInlineInput
          name="conversionFactor"
          initialValues={initialValues}
          parentInputComponent={NumberInlineInput}
          validate={(value) => {
            if (value <= 0) throw new Error('Conversion factor must be a positive number.')
          }}
          inputProps={{ min: 0, step: 0.01 }}
        />
      </div>
    ),

    status: (
      <UnitOfMeasureInlineInput
        name="status"
        initialValues={initialValues}
        parentInputComponent={StatusSelectInlineInput}
        inputProps={{ isClearable: false }}
      />
    ),

    updatedAt: <LocalDateTime value={updatedAt} />,
  })
}
